// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__eyUqo","rootSuccess":"CompleteLink_rootSuccess__3PNXe","rootFailure":"CompleteLink_rootFailure__2Wtaf","isDisabled":"CompleteLink_isDisabled__2HyR_"};